export const tpwd = {
  agencyCode: '802',
  name: 'Texas Parks and Wildlife Department',
  shortName: 'TPWD',
  slug: 'tpwd',
};
